import React, { useEffect } from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { isValidNewOffice } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { BACKEND_APIS } from "@constants"
import useAdminNewOfficeInfo from "Pages/Admin/Users/@hooks/useNewOfficeInfo"

export default function OfficeTimeZoneField() {

	const { tz, setTzInfo } = useAdminNewOfficeInfo("", "tz")

	const { errors, isValid } = useValidatorSeeker(
		{ tz: tz },
		object({
			tz: string().required('Must provide a Time Zone')
		})
	)

	useEffect(() => {
		isValidNewOffice.value = { ...isValidNewOffice.peek(), tz: isValid }
	}, [isValid])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/date/options/timezone`}
		value={tz}
		label="Office Time Zone"
		placeholder="Office Time Zone"
		onChange={e => setTzInfo(e.target.value)}
		error={errors?.tz}
	/>
}